import { format, differenceInMinutes } from "date-fns";

export const exportBookingsAsCSV = (bookings: any[]) => {
  if (!bookings.length) {
    alert("No bookings to export");
    return;
  }

  // Define the columns and their headers
  const columns = [
    { id: "date", label: "Date" },
    { id: "startTime", label: "Start Time" },
    { id: "endTime", label: "End Time" },
    { id: "user", label: "User" },
    { id: "bike", label: "Bike" },
    { id: "rideType", label: "Ride Type" },
    { id: "status", label: "Status" },
    { id: "startLocation", label: "Start Location" },
    { id: "endLocation", label: "End Location" },
    { id: "duration", label: "Duration (min)" },
  ];

  // Map bookings to CSV rows
  const rows = bookings.map((booking) => {
    const start = new Date(booking.start_time);
    const end = new Date(booking.end_time);
    const duration = differenceInMinutes(end, start);
    return {
      date: format(start, "yyyy-MM-dd"),
      startTime: format(start, "HH:mm"),
      endTime: format(end, "HH:mm"),
      user: booking.user?.username || booking.user_id || "",
      bike: booking.bike?.serial_number || booking.bike || booking.bike_id || "Unknown",
      rideType: booking.ride_type || "-",
      status: booking.status || "-",
      startLocation:
        booking.start_location_type === "site"
          ? booking.start_site?.name || booking.start_location_id || "Site"
          : "Home",
      endLocation:
        booking.end_location_type === "site"
          ? booking.end_site?.name || booking.end_location_id || "Site"
          : "Home",
      duration: duration,
    };
  });

  // Create CSV content
  const csvContent = [
    columns.map((col) => col.label).join(","),
    ...rows.map((row) => columns.map((col) => row[col.id]).join(",")),
  ].join("\n");

  // Download CSV
  const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const csvUrl = URL.createObjectURL(csvBlob);
  const csvLink = document.createElement("a");
  csvLink.href = csvUrl;
  csvLink.setAttribute("download", `bookings_export_${new Date().toISOString().split("T")[0]}.csv`);
  document.body.appendChild(csvLink);
  csvLink.click();
  document.body.removeChild(csvLink);
}; 